import { FooterContent } from "@/types/footer";

export const defaultFooterContent: FooterContent = {
    logo: {
        src: "/logo.svg",
        alt: "Logo",
    },
    copyright: "©2024 All rights reserved",
    contact: {
        phone: "(555) 123-4567",
        fax: "(555) 123-4568",
        address: "123 Medical Plaza, Suite 100, Sacramento, CA 95825",
        officeHours: "Mondays: 1:00pm - 5:00pm\nTuesdays: 8:00am - 5:00pm\nWednesdays: 8:00am - 5:00pm\nThursdays: 8:00am - 5:00pm\nFridays: 8:00am - 12:00pm\nSaturdays: Closed\nSundays: Closed",
        bookingLink: "/booking"
    },
    socialLinks: [
        { label: "Facebook", url: "https://facebook.com" },
        { label: "Instagram", url: "https://instagram.com" },
        { label: "Twitter", url: "https://twitter.com" },
        { label: "LinkedIn", url: "https://linkedin.com" },
        { label: "YouTube", url: "https://youtube.com" },
    ],
    legalLinks: [
        { label: "Privacy", url: "/privacy" },
        { label: "Security", url: "/security" },
        { label: "User terms", url: "/user-terms" },
        { label: "Customer terms", url: "/customer-terms" },
        { label: "Google Reviews", url: "https://www.google.com", opensInNewTab: true },
    ],
    columns: [
        { columnName: "Company", label: "About Us", url: "/about" },
        { columnName: "Company", label: "Contact", url: "/contact" },
        { columnName: "Company", label: "Careers", url: "/careers" },
        { columnName: "Company", label: "Blog", url: "/blog" },
        { columnName: "Resources", label: "Patient Forms", url: "/patient-forms" },
        { columnName: "Resources", label: "Insurance", url: "/insurance" },
        { columnName: "Resources", label: "FAQs", url: "/faqs" },
        { columnName: "Resources", label: "Patient Portal", url: "/portal" },
    ],
}; 